import { useLazyQuery } from "@apollo/client";
import { GET_EQUIPMENT_DATA } from "components/gql/gql_queries";
import { GetData } from "contexts/DataContext";
import {
  consoleBeauty,
  isIdentical,
  isObjectEmpty,
  logGQLError,
} from "data/functions";

export function GetEquipmentDataQuery() {
  const queryName = "GetEquipmentData";
  const { dataObj, forceSetDataObj } = GetData();
  const [refetch, variables] = useLazyQuery(GET_EQUIPMENT_DATA, {
    fetchPolicy: "no-cache",

    onCompleted: (data) => {
      let res = data?.payment_getEquipmentData;
      if (isObjectEmpty(res)) {
        forceSetDataObj({}, "equipmentData");
      } else if (!isIdentical(res, dataObj?.equipmentData)) {
        consoleBeauty("Получен список оборудования", "GraphQL", "darkgreen");
        forceSetDataObj(res, "equipmentData");
      }
    },
    onError: (e) => {
      forceSetDataObj({}, "equipmentData");
      if (e?.message?.includes("Invalid or expired token")) {
        consoleBeauty("Попытка обновить токен", "KeyCloak", "dimgrey");
        forceSetDataObj(true, "needToRefreshToken");
      }

      logGQLError(queryName, e);
    },
  });
  return [refetch, variables];
}
